module.exports = __webpack_public_path__ + "static/media/BlingV3_04.84b0574b.png";